import React from 'react'

const AddWelcomeScreen = () => {
    return ( <h1>here is the add welcome screen</h1> );
}
 
export default AddWelcomeScreen;